module.exports = __webpack_public_path__ + "assets1752041109707/img/avator.bd584bb1.png";